<template>
	<div class="c">
		<div class="header">
			工单详情
			<common-icon class="header-close"
			    :size="dp2p(24)"
			    color="#9DDBE5"
			    type="ios-close-circle"
			    @click.native="close" />
		</div>
		<div class="info flex column">
			<div class="flex">
				<div class="form-label">工单号</div>
				<div class="form-value">{{ info.orderNo }}</div>
			</div>
			<div class="flex">
				<div class="form-label">服务类别</div>
				<div class="form-value">{{ dict.serviceType.val(info.serviceType) }}</div>
			</div>
			<div class="flex">
				<div class="form-label">业务类别</div>
				<div class="form-value">{{ dict.busType.val(info.busType) }}</div>
			</div>
			<div class="flex">
				<div class="form-label">要求完成时间</div>
				<div class="form-value">{{ info.planCompleteTime | ymdL }}</div>
			</div>
			<div class="flex">
				<div class="form-label">需求描述</div>
				<div class="form-value"
				    style="white-space: pre-wrap;">{{ info.description }}</div>
			</div>
			<div class="flex">
				<div class="form-label">实施地址</div>
				<div class="form-value">{{ info.addr }}</div>
			</div>
			<div class="flex">
				<div class="form-label">报单人</div>
				<div class="form-value">{{ info.createUserName }}</div>
			</div>
			<div class="flex">
				<div class="form-label">报单电话</div>
				<div class="form-value">{{ info.createUserPhone }}</div>
			</div>
			<div class="flex">
				<div class="form-label">联系人</div>
				<div class="form-value">{{ info.contactName }}</div>
			</div>
			<div class="flex">
				<div class="form-label">联系电话</div>
				<div class="form-value">{{ info.contactPhone }}</div>
			</div>
			<div class="flex">
				<div class="form-label">执行人</div>
				<div class="form-value">{{ info.execUserName }}</div>
			</div>
			<div class="flex">
				<div class="form-label">执行人电话</div>
				<div class="form-value">{{ info.execUserPhone }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import { orderView } from '@/api/order-manage'
import theme from './theme'

export default {
	name: "OrderDetail",

	mixins: [theme],

	inject: {
		$modal: {
			default: null
		}
	},

	props: {
		id: {
			type: [String, Number],
			required: true,
		},
	},

	data() {
		return {
			info: {
				acceptAssess: '',
				acceptTime: '',
				addr: '',
				assginTime: '',
				assignUserId: '',
				assignUserName: '',
				attachments: '',
				busType: '',
				contactName: '',
				contactPhone: '',
				createTime: '',
				createUserId: '',
				createUserName: '',
				createUserPhone: '',
				delay: '',
				description: '',
				execAvatar: '',
				execUserId: '',
				execUserName: '',
				execUserPhone: '',
				geoJson: '',
				id: '',
				orderDataSource: '',
				orderNo: '',
				orderStatus: '',
				planCompleteTime: '',
				realCompleteTime: '',
				remark: '',
				repulseStatus: '',
				score: '',
				serviceType: '',
			},

			dict: {
				serviceType: this.$dict.NULL,
				busType: this.$dict.NULL,
			},
		}
	},

	created() {
		Promise.all([
			this.$dict.get(['service_type', 'bus_type']),
			orderView(this.id),
		]).then(args => {
			var [dictGroup, view] = args

			this.dict.serviceType = dictGroup.serviceType
			this.dict.busType = dictGroup.busType

			Object.assign(this.info, view.data)
		})
	},

	methods: {
		close() {
			this.$modal.close()
		}
	},
}
</script>
<style lang="less"
    scoped>
@import './theme.less';

.c {
	width: 100%;
	height: 100%;
	border: 1px solid #1F4A95;
	border-radius: 16px;
	overflow: auto;
	background-color: rgba(4, 17, 52, 0.7);
}

.header {
	border-bottom: 1px solid #1F4A95;
	padding: 12px 20px;
	font-size: 18px;
	color: #9DDBE5;

	&-close {
		float: right;
		position: relative;
		top: 2px;
		cursor: pointer;
	}
}

.info {
	padding: 24px 24px;
	font-size: 14px;
	font-weight: bold;
	line-height: 16px;
	color: @os-label-color;
}

.form {
	&-label {
		min-width: 180px;
		margin-bottom: 18px;
	}

	&-value {
		margin-bottom: 18px;
		color: #9DDBE5;
	}
}
</style>